document.addEventListener('DOMContentLoaded', () => {
  const NAV_KEYS = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canObserve = 'IntersectionObserver' in window;

  const initReveal = (root) => {
    if (!canObserve || reducedMotion.matches) return;

    root.classList.add('is-reveal-ready');
    const observer = new IntersectionObserver((entries) => {
      for (const { isIntersecting, target } of entries) {
        if (!isIntersecting) continue;
        target.classList.add('is-visible');
        observer.unobserve(target);
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -10px 0px' });

    for (const item of root.querySelectorAll('[data-ppa-reveal]')) observer.observe(item);
  };

  const initBrowser = (browser) => {
    const tabs = [...browser.querySelectorAll('[role="tab"]')];
    const viewButtons = [...browser.querySelectorAll('.ppa-results__view')];
    const images = [...browser.querySelectorAll('.ppa-results__image')];
    const nameEl = browser.querySelector('[data-ppa-results-name]');
    const { sizesBoth, sizesSingle } = browser.dataset;

    const setView = (view) => {
      browser.dataset.view = view;
      for (const button of viewButtons) {
        button.setAttribute('aria-pressed', String(button.dataset.view === view));
      }
      const sizes = view === 'both' ? sizesBoth : sizesSingle;
      for (const image of images) image.sizes = sizes;
    };

    const selectTab = (tab) => {
      for (const item of tabs) {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      }
      if (nameEl) nameEl.textContent = tab.dataset.name;
      setView('both');
    };

    browser.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) {
        selectTab(tab);
        return;
      }

      const viewButton = event.target.closest('.ppa-results__view');
      if (viewButton) setView(viewButton.dataset.view);
    });

    browser.addEventListener('keydown', (event) => {
      const index = tabs.indexOf(event.target);
      if (index === -1 || !NAV_KEYS.includes(event.key)) return;

      event.preventDefault();
      const lastIndex = tabs.length - 1;
      const targetIndex = {
        Home: 0,
        End: lastIndex,
        ArrowLeft: (index + lastIndex) % tabs.length,
        ArrowRight: (index + 1) % tabs.length,
      }[event.key];

      tabs[targetIndex].focus();
      selectTab(tabs[targetIndex]);
    });

    const warmPhotos = () => {
      if (navigator.connection?.saveData) return;
      for (const image of images) image.loading = 'eager';
    };

    if (!canObserve) {
      warmPhotos();
      return;
    }

    const warmObserver = new IntersectionObserver((entries) => {
      if (!entries.some(({ isIntersecting }) => isIntersecting)) return;
      warmPhotos();
      warmObserver.disconnect();
    }, { rootMargin: '900px 0px' });
    warmObserver.observe(browser);
  };

  for (const root of document.querySelectorAll('[data-ppa-results]')) {
    initReveal(root);
    const browser = root.querySelector('[data-ppa-results-browser]');
    if (browser) initBrowser(browser);
  }
});
